import {
  AvgDaysToFulfillOverTimeRequestSchema,
  AvgDaysToFulfillOverTimeResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getAvgDaysToFulfillOverTime = {
  name: "getAvgDaysToFulfillOverTime" as const,
  input: AvgDaysToFulfillOverTimeRequestSchema,
  output: AvgDaysToFulfillOverTimeResponseSchema,
};
